module.exports = __webpack_public_path__ + "img/wallet-left-dark.ea66892a.svg";